import { useMe } from './api/queries';
import { isUnauthorized } from './api/http';
import { AppShell } from './app/AppShell';
import { LoginScreen } from './features/login/LoginScreen';
import { de } from './i18n/de';

/**
 * Authentication gate. Without a session there is no access to any data, so the
 * login card is the whole app until `me` resolves.
 */
export function App() {
  const me = useMe();

  if (me.isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-surface">
        <span className="sr-only">{de.app.name}</span>
      </div>
    );
  }

  if (me.isError) {
    if (isUnauthorized(me.error)) return <LoginScreen />;
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-surface px-6 text-center">
        <p className="text-body text-fg-muted">{de.errors.loadFailed}</p>
        <button
          type="button"
          onClick={() => void me.refetch()}
          className="rounded-control border border-line px-3 py-2 text-body text-fg-secondary"
        >
          {de.errors.retry}
        </button>
      </div>
    );
  }

  return <AppShell user={me.data} />;
}
